import React from "react";
import { observable, action } from "mobx";
import { inject, observer } from "mobx-react";

import { STORE_MAP } from "../../Store/MapStore";
import { STORE_TABLE } from "../../Store/TableStore";
import {
  DIRECTION_BOTTOM,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_TOP,
} from "./Map";

@inject((stores) => ({
  store: stores.store.get(STORE_MAP),
  tableStore: stores.store.get(STORE_TABLE),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class MapBin extends React.Component {
  @observable showFloatingInfo = false;

  //prettier-ignore
  getStyle = () => {
    const { bin, block, store, direction, corridorDirection } = this.props;
    const { scaled } = store;
    const style = {};

    if (direction === DIRECTION_LEFT) {
      style.width = scaled(block.Length);
      style.height = scaled(bin.End - bin.Start);
      style.top = scaled(block.Baseline.Start.Y + corridorDirection.Y * (corridorDirection.Y === 1 ? bin.Start : bin.End));
      style.left = scaled(block.Baseline.Start.X);
      style.justifyContent = 'flex-start';

    } else if (direction === DIRECTION_RIGHT) {
      style.width = scaled(block.Length);
      style.height = scaled(bin.End - bin.Start);
      style.top = scaled(block.Baseline.Start.Y + corridorDirection.Y * (corridorDirection.Y === 1 ? bin.Start : bin.End));
      style.left = scaled(block.Baseline.Start.X - block.Length);
      style.justifyContent = 'flex-end';
      style.alignItems = 'flex-end';

    } else if (direction === DIRECTION_BOTTOM) {
      style.width = scaled(bin.End - bin.Start);
      style.height = scaled(block.Length);
      style.top = scaled(block.Baseline.Start.Y - block.Length);
      style.left = scaled(block.Baseline.Start.X + corridorDirection.X * (corridorDirection.X === 1 ? bin.Start : bin.End));
      style.flexDirection = 'column';
      style.alignItems = 'flex-end';

    } else if (direction === DIRECTION_TOP) {
      style.width = scaled(bin.End - bin.Start);
      style.height = scaled(block.Length);
      style.top = scaled(block.Baseline.Start.Y);
      style.left = scaled(block.Baseline.Start.X + corridorDirection.X * (corridorDirection.X === 1 ? bin.Start : bin.End));
      style.flexDirection = 'column';
      style.alignItems = 'flex-start';
    }
    return style;
  };

  getSaturationStyle = () => {
    const { bin, direction, store } = this.props;
    const { warehouseSaturations } = store;
    return {
      [direction === DIRECTION_LEFT || direction === DIRECTION_RIGHT
        ? "width"
        : "height"]: warehouseSaturations.hasOwnProperty(bin.Id)
        ? ((0 * warehouseSaturations[bin.Id]) / bin.Capacity) * 100 + "%"
        : 0,
    };
  };

  onClick = () => {
    const { store, bin, socket } = this.props;
    if (store.detailedBinId === bin.Id) {
      store.setDetailedBinId(null);
      return;
    }
    store.setDetailedBinId(bin.Id);
    socket.emitWithToken("GetBinData", { BinId: bin.Id }, (err, data) => {
      if (err) {
        console.error(err);
        return;
      }
      store.setBinDetails(bin.Id, data);
    });
  };

  @action onMouseEnter = () => {
    this.showFloatingInfo = true;
  };

  @action onMouseLeave = () => {
    this.showFloatingInfo = false;
  };

  onMouseMove = (e) => {
    this.props.store.setMousePosition({ x: e.clientX + 10, y: e.clientY + 10 });
  };

  render() {
    const { direction, bin, store } = this.props;
    const { detailedBinId, warehouseSaturations } = store;

    const levels =
      warehouseSaturations && warehouseSaturations.hasOwnProperty(bin.Id)
        ? warehouseSaturations[bin.Id]
        : null;
    const saturations = [];
    let palletnum = 0;
    if (levels) {
      for (let i = 0; i < bin.LevelNum; i++) {
        let level =
          direction === DIRECTION_BOTTOM || direction === DIRECTION_RIGHT
            ? bin.LevelNum - i - 1
            : i;
        saturations.push(
          <MapLevel
            key={bin.Id + "-" + level}
            direction={direction}
            saturation={levels[level] ? levels[level] : 0}
            capacity={bin.Capacity}
          />
        );
        if (levels[level]) palletnum += levels[level];
      }
    }

    const style = this.getStyle();

    return (
      <div
        key={bin.Id}
        className={
          "map__bin bin" + (detailedBinId === bin.Id ? " bin--detailed" : "")
        }
        style={this.getStyle()}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onMouseMove={this.onMouseMove}
        onClick={this.onClick}
      >
        <div className="bin__inner">
          <div
            className={
              "bin__bg " + (style.flexDirection ? "vertical" : "horizontal")
            }
          >
            {saturations}
          </div>
        </div>
        {this.showFloatingInfo && (
          <div
            className="bin__floating-info"
            style={{ left: store.mousePosition.x, top: store.mousePosition.y }}
          >
            <div>
              Sor: <span>{bin.Id}</span>
            </div>
            {warehouseSaturations.hasOwnProperty(bin.Id) && (
              <React.Fragment>
                <div>
                  Raklapok: <span>{palletnum}db</span>
                </div>
                <div>
                  Kihasználtság:{" "}
                  <span>
                    {Math.ceil(
                      (palletnum / (bin.Capacity * bin.LevelNum)) * 100
                    )}
                    %
                  </span>
                </div>
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    );
  }
}

@observer
class MapLevel extends React.Component {
  getSaturationStyle = () => {
    const { direction, saturation, capacity } = this.props;
    return {
      [direction === DIRECTION_LEFT || direction === DIRECTION_RIGHT
        ? "width"
        : "height"]: (saturation / capacity) * 100 + "%",
    };
  };
  render() {
    return (
      <div className="bin__saturation" style={this.getSaturationStyle()} />
    );
  }
}

export default MapBin;
